import http from '../utils/http';

export default {
    async getABCInformation() {
        const { list } = await http.post('-admin/manage/code-list', {
            mode: 'L',
            search_value1: 'DEPT_CD',
            search_value2: '',
            search_value3: '',
            search_value4: 'Y',
            search_value5: 'N',
            page_num: '0',
            page_per_size: '100',
        });
        const ABCInfo = [];
        list.forEach((n) => {
            ABCInfo.push({
                cd: n.cd.trim(),
                cdName: n.cd_name.trim(),
            });
        });

        return ABCInfo;
    },
    async getNoticeList() {
        const list = await http.post('/notice/list', {"page_number": 0, "page_size": 100});
        return list;
    },

};
